<template>
<div class="MsgSet">
    <div class="top_warp spackage bgc box-shadow">
        <div class="title_text_box flex_center">
            <p>基本选项</p>
            <span class="flex_center"><img :src="require('@/common/images/taskToolsImgs/qus_icon.png')" alt="">如何选择消息类型？</span>
        </div>
        <div class="basic_options_box">
            <p>当前参与公众号类型：服务号</p>
            <div class="msg_type_box">
                <span>消息类型</span>
                <el-radio v-model="radio" label="1">
                    客服消息
                    <el-tooltip placement="top">
                        <div class="tooltip_content" slot="content">客服消息支持服务号和订阅号</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </el-radio>
                <el-radio v-model="radio" label="2" disabled>
                <!-- <el-radio v-model="radio" label="2"> -->
                    模版消息
                    <el-tooltip placement="top">
                        <div class="tooltip_content" slot="content">模版消息支持服务号且支持服务号发送模版消息，订阅号发客服消息</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </el-radio>
            </div>
        </div>
    </div>
    <div class="invitees_tips_warp spackage bgc box-shadow">
        <div class="title_text_box flex_center">
            <p>受邀者提示</p>
            <span class="flex_center"><img :src="require('@/common/images/taskToolsImgs/qus_icon.png')" alt="">什么是受邀者提示？</span>
        </div>
        <div class="content_box">
            <!-- 1 -->
            <!-- <div class="msg_set_item" :data="text1" contenteditable="false"> -->
            <div class="msg_set_item">
                <p class="tips_text flex_center">
                    助力成功
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">若系统判断用户属于第一次关注，则弹出的提示语</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg1" contenteditable="true" class="contenteditable-input" v-html="text1"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg1', '[链接]')" type="text">[链接]</el-button>
                    <el-button @click="shortcutBtn('msg1', '[邀请者昵称]')" type="text">[邀请者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg1', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg1', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg1', eventDetails)" type="text">[活动详情]</el-button>
                </div>
            </div>
            <!-- 2.1 -->
            <div v-if="true" class="msg_set_item">
                <p class="tips_text flex_center">
                    重复参与
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">如果设置为自动生成助力或者已经有助力</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg2" contenteditable="true" class="contenteditable-input" v-html="text2"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg2', '[链接]')" type="text">[链接]</el-button>
                    <el-button @click="shortcutBtn('msg2', '[邀请者昵称]')" type="text">[邀请者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg2', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg2', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg2', eventDetails)" type="text">[活动详情]</el-button>
                </div>
            </div>
            <!-- 2.2 -->
            <!-- <div v-if="false" class="msg_set_item">
                <p class="tips_text flex_center">
                    重复参与
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">如果设置为自动生成助力或者已经有助力</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg2" contenteditable="true" class="contenteditable-input" v-html="text21"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg2', '[邀请者昵称]')" type="text">[邀请者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg2', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg2', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg2', '[活动详情]')" type="text">[活动详情]</el-button>
                </div>
            </div> -->
            <!-- 3.1 -->
            <div v-if="true" class="msg_set_item">
                <p class="tips_text flex_center">
                    关注公众号提醒
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">如果设置为自动生成助力或者已经有助力</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg3" contenteditable="true" class="contenteditable-input" v-html="text3"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg3', '[链接]')" type="text">[链接]</el-button>
                    <el-button @click="shortcutBtn('msg3', '[邀请者昵称]')" type="text">[邀请者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg3', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg3', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg3', eventDetails)" type="text">[活动详情]</el-button>
                </div>
            </div>
            <!-- 3.2 -->
            <!-- <div v-if="false" class="msg_set_item">
                <p class="tips_text flex_center">
                    关注公众号提醒
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">如果设置为自动生成助力或者已经有助力</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg3" contenteditable="true" class="contenteditable-input" v-html="text31"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg3', '[邀请者昵称]')" type="text">[邀请者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg3', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg3', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg3', '[活动详情]')" type="text">[活动详情]</el-button>
                </div>
            </div> -->
        </div>
    </div>
    <div class="inviter_tips_warp spackage bgc box-shadow">
        <div class="title_text_box flex_center">
            <p>邀请者提示</p>
            <span class="flex_center"><img :src="require('@/common/images/taskToolsImgs/qus_icon.png')" alt="">什么是邀请者提示？</span>
        </div>
        <div class="content_box">
            <!-- 4 -->
            <div class="msg_set_item">
                <p class="tips_text flex_center">
                    新成员加入
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">被邀请人关注公众号并且参与助力通知邀请者</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg4" contenteditable="true" class="contenteditable-input" v-html="text4"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg4', '[链接]')" type="text">[链接]</el-button>
                    <el-button @click="shortcutBtn('msg4', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg4', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg4', '[奖品剩余数]')" type="text">[奖品剩余数]</el-button>
                    <el-button @click="shortcutBtn('msg4', '[任务量]')" type="text">[任务量]</el-button>
                    <el-button @click="shortcutBtn('msg4', '[已完成任务量]')" type="text">[已完成任务量]</el-button>
                    <el-button @click="shortcutBtn('msg4', '[未完成量]')" type="text">[未完成量]</el-button>
                    <el-button @click="shortcutBtn('msg4', eventDetails)" type="text">[活动详情]</el-button>
                    <el-button @click="shortcutBtn('msg4', assDetails)" type="text">[邀请记录]</el-button>
                </div>
            </div>
            <!-- 5 -->
            <div class="msg_set_item">
                <p class="tips_text flex_center">
                    助力完成
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">邀请者的任务完成后通知邀请者</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg5" contenteditable="true" class="contenteditable-input" v-html="text5"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg5', '[链接]')" type="text">[链接]</el-button>
                    <el-button @click="shortcutBtn('msg5', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg5', '[受邀者昵称]')" type="text">[受邀者昵称]</el-button>
                    <el-button @click="shortcutBtn('msg5', '[奖品剩余数]')" type="text">[奖品剩余数]</el-button>
                    <el-button @click="shortcutBtn('msg5', '[任务量]')" type="text">[任务量]</el-button>
                    <el-button @click="shortcutBtn('msg5', '[已完成任务量]')" type="text">[已完成任务量]</el-button>
                    <el-button @click="shortcutBtn('msg5', eventDetails)" type="text">[活动详情]</el-button>
                    <el-button @click="shortcutBtn('msg5', assDetails)" type="text">[邀请记录]</el-button>
                </div>
            </div>
            <!-- 6 -->
            <div class="msg_set_item">
                <p class="tips_text flex_center">
                    发起助力成功
                    <el-tooltip placement="top-start">
                        <div class="tooltip_content" slot="content">邀请者发起任务后通知邀请者</div>
                        <img class="tooltip_icon" :src="require('@/common/images/taskToolsImgs/tips_icon.png')" alt="">
                    </el-tooltip>
                </p>
                <div id="msg6" contenteditable="true" class="contenteditable-input" v-html="text6"></div>
                <div class="btn_box">
                    <el-button @click="shortcutBtn('msg6', '[链接]')" type="text">[链接]</el-button>
                    <el-button @click="shortcutBtn('msg6', '[活动名称]')" type="text">[活动名称]</el-button>
                    <el-button @click="shortcutBtn('msg6', '[奖品剩余数]')" type="text">[奖品剩余数]</el-button>
                    <el-button @click="shortcutBtn('msg6', '[任务量]')" type="text">[任务量]</el-button>
                    <el-button @click="shortcutBtn('msg6', '[已完成任务量]')" type="text">[已完成任务量]</el-button>
                    <el-button @click="shortcutBtn('msg6', '[未完成量]')" type="text">[未完成量]</el-button>
                    <!-- <el-button @click="shortcutBtn('msg6', '[活动详情]')" type="text">[活动详情]</el-button> -->
                    <el-button @click="shortcutBtn('msg6', eventDetails)" type="text">[活动详情]</el-button>
                    <!-- <el-button @click="shortcutBtn('msg6', '[邀请记录]')" type="text">[邀请记录]</el-button> -->
                    <el-button @click="shortcutBtn('msg6', assDetails)" type="text">[邀请记录]</el-button>
                </div>
            </div>
        </div>
        <div class="submit_box">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submitBtn">提交</el-button>
        </div>
        <div class="link_set_pop_box">
            <el-dialog @close='closeDialog' title="助力排行" :visible.sync="dialogVisible">
                <div class="link_set_pop_div">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="选择链接">
                            <el-select v-model="ruleForm.linkType" style="width: 400px;" placeholder="请选择链接">
                                <el-option v-for="(item, index) in linkOption" :key="index" :label="item.name" :value="item.val"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="链接描述" prop="linkDescribe">
                            <el-input v-model="ruleForm.linkDescribe" placeholder="请输入链接描述" style="width: 400px;"></el-input>
                        </el-form-item>
                        <el-form-item v-if="ruleForm.linkType !== '' && ruleForm.linkType !== '{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}' && ruleForm.linkType !== '{hostname}/m/mkass/reHeDet?eventid={eventid}&assid={asscode}' && ruleForm.linkType !== '{hostname}/m/mkass/heDet?eventid={eventid}&assid={asscode}'" label="链接地址">
                            <el-input v-model="ruleForm.linkUrl" placeholder="链接地址必须以 http:// 或 https:// 开头" style="width: 400px;"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="btn_div">
                        <el-button plain @click="cancelBtn">取消</el-button>
                        <el-button type="primary" @click="submitForm('ruleForm', divId, aTag)">提交</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>

</div>
</template>

<script>
import {getAssEventServiceMessageInfo, updateAssEventServiceMessage} from 'api/taskToolsApi2'
import {mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MsgSet',
    data() {
        return {
            aTag: '',
            dialogVisible: false,
            linkOption: [
                {
                    name: '活动详情',
                    val: '{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}'
                },
                {
                    name: '助力详情',
                    val: '{hostname}/m/mkass/reHeDet?eventid={eventid}&assid={asscode}'
                },
                {
                    name: '自定义链接',
                    val: 'CustomLink'
                }
            ],
            ruleForm: {
                linkType: '',
                linkDescribe: '',
                linkUrl: ''
            },
            rules: {
                linkDescribe: [
                    {required: true, message: '请填写链接描述', trigger: 'blur'}
                ]
            },
            radio: '1',
            divId: '',
            text1: `@[受邀者昵称]，您成功为【[邀请者昵称]】助力<br />他正在参加[活动名称]<br /><br /><a href="{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}" contenteditable="false" class="insert-link">→点击查看[活动详情]</a><br /><br />本次活动真实有效，如有问题请添加微信客服:xxx`,
            text2: `@[受邀者昵称]，您已经参与过该活动，不可重复助力<br /><br /><a href="{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}" contenteditable="false" class="insert-link">→点击查看[活动详情]</a><br /><br />本次活动真实有效，如有问题请添加微信客服:xxx`,
            // text21: `@[受邀者昵称]，您已经参与过该活动，不可重复助力<br />您已经有自己的专属海报<br /><br /><a contenteditable="false" class="insert-link">→点击查看[活动详情]，生成您的专属活动海报吧！</a><br /><br />本次活动真实有效，如有问题请添加微信客服:xxx`,
            text3: `[受邀者昵称],您好<br />您来啦~活动正在进行<br /><br />本次活动奖品:【xxx】<br />仅需【xxx】个好友支持，即可包邮免费领取<br /><br /><a href="{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}" contenteditable="false" class="insert-link">→点击查看[活动详情]</a><br /><br />本次活动真实有效，如有问题请添加微信客服:【xxx】`,
            // text31: `[受邀者昵称],您好<br />您来啦~活动正在进行<br /><br />本次活动奖品:【xxx】<br />仅需【xxx】个好友支持，即可包邮免费领取<br /><br /><a href="{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}" contenteditable="false" class="insert-link">→点击查看[活动详情]，生成您的专属活动海报</a><br /><br />本次活动真实有效，如有问题请添加微信客服:【xxx】`,
            text4: '',
            text5: '',
            text6: '',
            eventDetails: '<a href="{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}" contenteditable="false" class="insert-link">[活动详情]</a>',
            assDetails: '',
            range: null
        }
    },
    mounted() {
        this.assTypeFn(this.$route.query.asstype)
        this.$nextTick(() => {
            var _this = this
            // todo 这里参数如果是中文有问题，检查一下
            $('.MsgSet').on('click', '.insert-link', function(event) {
                // let p=this.innerHTML.slice(1, -1)
                // console.log('this.parent.id', $(this).parent().attr('id'))
                // console.log('this.href', $(this).attr('href'))
                // console.log('this', this)
                // console.log('this.innerHTML:', this.innerHTML)
                // console.log(_this.aTag)
                _this.aTag = this
                _this.divId = $(this).parent().attr('id')
                _this.ruleForm.linkType = $(this).attr('href')
                if ($(this).attr('href') !== '' && $(this).attr('href') !== '{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}' && $(this).attr('href') !== '{hostname}/m/mkass/reHeDet?eventid={eventid}&assid={asscode}' && $(this).attr('href') !== '{hostname}/m/mkass/heDet?eventid={eventid}&assid={asscode}') {
                    _this.ruleForm.linkType = 'CustomLink'
                }
                _this.ruleForm.linkUrl = $(this).attr('href')
                _this.ruleForm.linkDescribe = this.innerHTML
                _this.dialogVisible = true
                event.stopPropagation()
                return false
            })
        })
        this.getMsgInfo()
    },
    methods: {
        assTypeFn(val) {
            var assUrl = ''
            if (parseInt(val) === 1 || parseInt(val) === 2) {
                assUrl = '{hostname}/m/mkass/reHeDet?eventid={eventid}&assid={asscode}'
            } else if (parseInt(val) === 3) {
                assUrl = '{hostname}/m/mkass/heDet?eventid={eventid}&assid={asscode}'
            }
            this.assDetails = `<a href="${assUrl}" contenteditable="false" class="insert-link">[邀请记录]</a>`
            this.linkOption[1].val = assUrl
            // this.text2 = `@[受邀者昵称]，您已经参与过该活动，不可重复助力<br />您已经有自己的专属海报<br /><br /><a href="${assUrl}" contenteditable="false" class="insert-link">→点击查看[邀请记录]</a><br /><br />本次活动真实有效，如有问题请添加微信客服:xxx`
            this.text4 = `新好友【[受邀者昵称]】来支持您啦~<br />您还差【[未完成量]】个新好友支持，就能领取【xxxx】奖品~<br />奖品暂剩余:【[奖品剩余数]】份<br /><br /><a href="${assUrl}" contenteditable="false" class="insert-link">点击→查看您的[邀请记录]</a><br /><a href="{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}" contenteditable="false" class="insert-link">点击→查看[活动详情]查看活动详情</a><br /><br />为了不频繁的打扰您，好友助力提醒暂时为您汇报到这里了，如好友支持没有进度显示，请不要着急，不影响实际兑换。`
            this.text5 = `~恭喜您完成任务 <br />【[活动名称]】<br />第[已完成任务量]个好友 @[受邀者昵称] 来支持您啦！<br /><br /><a href="${assUrl}" contenteditable="false" class="insert-link">请立即→点击这里查看[邀请记录]，了解您的任务结果！</a>`
            this.text6 = `~恭喜您创建任务成功 【[活动名称]】<br />任务量:[任务量]<br />未完成量:[未完成量]<br />奖品剩余数:[奖品剩余数]<br /><br /><a href="${assUrl}" contenteditable="false" class="insert-link">请立即→点击这里查看[邀请记录]，邀请您的好友来给您加油吧！</a>`
        },
        // 提交添加链接表单
        submitForm(formName, tagId, cont) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (cont !== '') {
                        // cont = 'www.baidu.com'
                        // console.log(cont)
                        // console.log(document.getElementById(tagId).getElementsByTagName('a'))
                        var linsArr = document.getElementById(tagId).getElementsByTagName('a')
                        for (let i = 0; i < linsArr.length; i++) {
                            if (linsArr[i] === cont) {
                                // console.log('1', linsArr[i])
                                // console.log('text', linsArr[i].text)
                                linsArr[i].href = this.ruleForm.linkUrl
                                linsArr[i].text = this.ruleForm.linkDescribe
                                this.aTag = ''
                                this.dialogVisible = false
                            }
                        }
                    } else {
                        // var shareUrl = `<a href="http://www.baidu.com" contenteditable="false" class="insert-link">www.baidu.com</a>`
                        var shareUrl = ``
                        if (this.ruleForm.linkType === 'CustomLink') {
                            shareUrl = `<a href="${this.ruleForm.linkUrl}" contenteditable="false" class="insert-link">${this.ruleForm.linkDescribe}</a>`
                        } else {
                            shareUrl = `<a href="${this.ruleForm.linkType}" contenteditable="false" class="insert-link">${this.ruleForm.linkDescribe}</a>`
                        }
                        // console.log(shareUrl)
                        this.dialogVisible = false
                        this.shortcutBtn(tagId, shareUrl)
                    }
                    this.range = null
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 取消按钮
        cancelBtn() {
            // this.$message.error(`取消`)
            this.closeDialog()
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        // 保存编辑框游标位置
        saveRange() {
            // 存起range
            let sel = window.getSelection()
            if (sel.getRangeAt && sel.rangeCount) {
                this.range = sel.getRangeAt(0)
            }
        },
        // 快捷添加编辑框字段按钮
        shortcutBtn(id, content) {
            this.ruleForm = {
                linkType: '{hostname}/m/mkass/oAssDetail?eventid={eventid}&assid={asscode}',
                linkDescribe: '',
                linkUrl: ''
            }
            this.aTag = ''
            this.divId = id
            document.getElementById(id).focus()
            // this.insertHtmlAtCaret('<img src="http://www.cnblogs.com/images/xml.gif" />')
            if (content === '[链接]') {
                this.dialogVisible = true
                this.saveRange()
            } else {
                // this.range = null
                this.insertHtmlAtCaret(content)
            }
        },
        // 插入内容
        insertHtmlAtCaret(html) {
            var sel, range
            if (window.getSelection) {
                sel = window.getSelection()
                if (sel.getRangeAt && sel.rangeCount) {
                    range = this.range || sel.getRangeAt(0)
                    range.deleteContents()
                    var el = document.createElement('div')
                    el.innerHTML = html
                    var frag = document.createDocumentFragment(), node, lastNode
                    while ((node = el.firstChild)) {
                        lastNode = frag.appendChild(node)
                    }
                    range.insertNode(frag)
                    if (lastNode) {
                        range = range.cloneRange()
                        range.setStartAfter(lastNode)
                        range.collapse(true)
                        sel.removeAllRanges()
                        sel.addRange(range)
                    }
                }
            } else if (document.selection && document.selection.type !== 'Control') {
                // IE < 9
                document.selection.createRange().pasteHTML(html)
            }
        },
        // 获取模板消息数据
        getMsgInfo() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getAssEventServiceMessageInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data.length)
                    if (data.data.length > 0) {
                        this.text1 = data.data[3].content
                        this.text2 = data.data[4].content
                        // this.text21 = data.data[4].content
                        this.text3 = data.data[5].content
                        // this.text31 = data.data[5].content
                        this.text4 = data.data[1].content
                        this.text5 = data.data[2].content
                        this.text6 = data.data[0].content
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 保存提交模板消息设置
        submitBtn() {
            var msg1 = $('#msg1').html()
            var msg2 = $('#msg2').html()
            var msg3 = $('#msg3').html()
            var msg4 = $('#msg4').html()
            var msg5 = $('#msg5').html()
            var msg6 = $('#msg6').html()
            var data = [
                {
                    msgtype: 1,
                    content: msg6
                },
                {
                    msgtype: 2,
                    content: msg4
                },
                {
                    msgtype: 3,
                    content: msg5
                },
                {
                    msgtype: 4,
                    content: msg1
                },
                {
                    msgtype: 5,
                    content: msg2
                },
                {
                    msgtype: 6,
                    content: msg3
                }
            ]
            // console.log('替换前：', data)
            var reg = new RegExp('&amp;', 'g')
            for (let i = 0; i < data.length; i++) {
                data[i].content = data[i].content.replace(reg, '&')
            }
            // console.log('替换后：', data)
            data = JSON.stringify(data)
            // console.log('JSON.stringify(data)：', data)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                messagelist: data
            }
            updateAssEventServiceMessage({
                data: Object.assign({}, params, this.shareSetParams),
                success: data => {
                    this.setLoading(false)
                    window.history.back()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        cancel() {
            window.history.back()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.el-tooltip__popper.is-dark {
    background: rgb(255, 255, 255)!important;
}
.MsgSet {
    min-width: 1192px;
    color: #303133;
    .flex_center {
        display: flex;
        align-items: center;
    }
    .title_text_box {
        padding: 0 20px;
        height: 60px;
        justify-content: space-between;
        border-bottom: 1px solid #DCDFE6;
        &>p {
            font-size:16px;
            border-left: 2px solid #409EFF;
            padding-left: 10px;
            font-weight: bold;
        }
        &>span {
            cursor: pointer;
            color: #409EFF;
            padding-top: 20px;
            img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }
    }
    .top_warp {
        .basic_options_box {
            padding: 20px 30px;
            .msg_type_box {
                margin-top: 20px;
                display: flex;
                align-items: center;
                &>span {
                    margin-right: 50px;
                }
                .el-radio {
                    display: flex;
                    align-items: center;
                    margin-right: 50px;
                }
                .el-radio__label {
                    display: flex;
                    align-items: center;
                    padding-bottom: 2px;
                }
            }
        }
    }
    .invitees_tips_warp {
        .content_box {
            padding-bottom: 30px!important;
        }
    }
    .invitees_tips_warp, .inviter_tips_warp {
        color: #303133;
        margin-top: 24px;
        .content_box {
            display: flex;
            justify-content: space-between;
            padding: 20px 30px;
            .msg_set_item {
                width: 500px;
                .tips_text {
                    margin-bottom: 10px;
                }
                .contenteditable-input {
                    min-height: 138px;
                    height: 262px;
                    resize: vertical;
                    padding: 5px 15px;
                    line-height: 1.5;
                    box-sizing: border-box;
                    width: 100%;
                    min-width: 364px;
                    font-size: inherit;
                    color: #606266;
                    background-color: #fff;
                    background-image: none;
                    border: 1px solid #dcdfe6;
                    border-radius: 4px;
                    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                    outline: none;
                    overflow-x: hidden;
                    overflow-y: auto;
                    cursor: text;
                    word-break: break-all;
                    white-space: pre-wrap;
                    -webkit-user-modify: read-write-plaintext-only;
                    user-modify: read-write-plaintext-only;
                }
                .contenteditable-input:focus {
                    border-color: #409EFF;
                }
                .contenteditable-input a {
                    cursor: pointer;
                    display: inline-block;
                    color: #409EFF;
                    // color: #00abff;
                    font-size: 14px;
                    margin: 0 2px;
                }
                .btn_box {
                    .el-button, .el-button--mini {
                        min-width: 30px;
                        margin-right: 10px;
                    }
                    .el-button+.el-button {
                        margin-left: 0px;
                    }
                }
            }
            .msg_set_item:nth-of-type(2n){
                margin: 0 20px;
            }
        }
        .submit_box {
            padding: 50px 30px;
            padding-top: 30px;
        }
    }
    // .inviter_tips_warp {
    //     color: #303133;
    //     margin-top: 24px;
    // }
    .link_set_pop_box {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
        }
        .el-dialog {
            width: 521px;
            margin: 0!important;
        }
        .el-dialog__body {
            padding: 20px 0;
        }
        .link_set_pop_div {
            .el-input__icon {
                line-height: 2px;
            }
            .btn_div {
                display: flex;
                justify-content: center;
                .el-button {
                    margin-bottom: 0px;
                }
            }
        }
    }
}
</style>
<style scoped>
    .tooltip_icon{
        cursor: pointer;
        margin-left: 10px;
        width: 15px;
        height: 15px;
    }
    .tooltip_content{
        color: #606266;
        text-align: center;
        padding: 0 15px;
        line-height: 20px;
    }
</style>